export const initialState = {
  practiceId: '',
  departmentId: null,
};

export const AthenaDepartmentIdOptions = [
  { label: 'Danvers', value: 1 },
  { label: 'GUIDE', value: 2 },
  { label: 'Downey', value: 4 },
  { label: 'San Jose', value: 5 },
  { label: 'Long Beach', value: 6 },
  { label: 'Test Department', value: 3 },
];
